export default "__VITE_ASSET__CPJ_ULld__"